import { ActionType } from "../../../../../../react-core/Flux/ActionType";
import { BaseStore } from "../../../../../../react-core/Flux/BaseStore";
import { CustomerSearchDispatcher } from "./Variable";

export interface CustomerSearchStaticState {
    isLoading?: boolean;
    actionType: ActionType;
    data?: any;
}

export class CustomerSearchStatic extends BaseStore<CustomerSearchStaticState> {
    constructor() {
        super();
        this.subscribeToDispatcher(CustomerSearchDispatcher, (actionData) => this.onCustomerSearchStoreResponse(actionData));
    }

    public getLastResult(): CustomerSearchStaticState {
        return this.getState();
    }

    public isLoading(): boolean {
        return this.getState().isLoading;
    }

    public getData() {
        return this.getState().data;
    }

    public getActionType() {
        return this.getState().actionType;
    }

    protected getDefaultState(): CustomerSearchStaticState {
        return { actionType: ActionType.Loading, data: null };
    }

    private onCustomerSearchStoreResponse(actionData): void {
        switch (actionData.actionType) {
            case ActionType.Success:
                this.setState({ actionType: actionData.actionType, data: actionData.payload });
                break;
            case ActionType.Update:
                    this.setState({ actionType: actionData.actionType, data: actionData.payload });
                    break;
            case ActionType.Error:
                this.setState({ actionType: actionData.actionType });
                break;
            case ActionType.Loading:
                this.setState({ actionType: actionData.actionType });
                break;
        }
    }
}